import React from 'react'

/**
 * Компонент для обработки непредвиденных и не перехваченных ошибок внутри компонента графика.
 */
class ErrorBoundary extends React.Component<any, State> {
  state: State = { hasError: false, errorMsg: '' }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorMsg: error.message }
  }

  componentDidCatch(error, info) {
    console.error(error, info)
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    return (
      <div className="flex-lines center" style={{ padding: '20px', display: 'flex', paddingTop: '50px' }}>
        <p className="text-error text-center text-pre">Произошла непредвиденная ошибка{'\n'}при отображении графика</p>
      </div>
    )
  }
}

interface State {
  hasError: boolean
  errorMsg: string
}

export default ErrorBoundary
